import React from 'react'

import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import AutoSizer from 'react-virtualized-auto-sizer'
import GridWrapper from './grid-wrapper'

const useStyles = makeStyles(() => ({
  thumbnailList: {
    width: '100%',
    height: '100%',
    paddingLeft: '13px',
    overflowX: 'hidden',
  },
}))

export const ThumbnailList = (props) => {
  const classes = useStyles(props)
  const {
    className = '',
    minSize = '153px',
    allowDrop = false,
  } = props

  return (
    <div className={`${classes.thumbnailList} ${className}`}>
      {<AutoSizer>
        {({ width, height }) => {
          return (
            <GridWrapper {...{ ...props, minSize, allowDrop, width, height }}></GridWrapper>
          )
        }}
      </AutoSizer>
      }
    </div>
  )
}
ThumbnailList.propTypes = {
  onSelectFile: PropTypes.func,
  onPreviewRequest: PropTypes.func.isRequired,
  onRefreshFiles: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func,
  onAddTag: PropTypes.func,
  className: PropTypes.string,
  minSize: PropTypes.string,
  allowDrop: PropTypes.bool,
  selectionEnabled: PropTypes.bool,
}

export default ThumbnailList
